import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { PhotoSlotButtonDesktop } from './PhotoSlotButtonDesktop';
import { PhotoSlotButtonMobile } from './PhotoSlotButtonMobile';
import type { PhotoSlotButtonProps } from './PhotoSlotButton.types';
import { Attributes } from 'react';

export const PhotoSlotButton = withWebResponsiveDesign<PhotoSlotButtonProps & Attributes>(
  PhotoSlotButtonMobile,
  PhotoSlotButtonMobile,
  PhotoSlotButtonDesktop,
);
